export default __webpack_public_path__ + "static/media/questionMark.2939e509.svg";